/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationStickerCheck = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationStickerCheck"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <g clipPath="url(#clip0_10273_589)">
        <path
          fill="var(--xdlColorIllustrationBackground)"
          d="m67.169 22.55-9.815-9.815-1.605-1.549-1.96-1.96-1.913 1.911-6.146-2.078a1.27 1.27 0 0 1-.786-.786L42.462.922l-1.688 4.99a3.305 3.305 0 0 0-3.178-2.425A3.304 3.304 0 0 0 34.3 6.785c0 1.473.97 2.724 2.304 3.147l-4.764 1.61 7.352 2.485c.366.125.66.416.785.786l.393 1.16A27 27 0 0 0 27.91 12.93C12.98 12.931.835 25.077.835 40.007S12.98 67.082 27.91 67.082s27.072-12.145 27.072-27.075c0-1.61-.148-3.226-.435-4.828z"
        />
        <path
          fill="#fff"
          d="M27.907 64.853c13.724 0 24.85-11.126 24.85-24.85s-11.126-24.85-24.85-24.85-24.85 11.125-24.85 24.85c0 13.724 11.125 24.85 24.85 24.85"
        />
        <path
          fill="#C6F16D"
          d="M26.52 56.123 7.473 37.07l8.247-8.243 10.8 10.801 27.268-27.264 8.243 8.247z"
        />
        <path
          fill="#FE813C"
          d="m42.08 8.983.378-1.122.378 1.122a3.47 3.47 0 0 0 2.18 2.18l1.122.378-1.122.378a3.47 3.47 0 0 0-2.18 2.18l-.378 1.122-.378-1.122a3.47 3.47 0 0 0-2.18-2.18l-1.121-.378 1.122-.378a3.47 3.47 0 0 0 2.18-2.18M37.596 7.865a1.077 1.077 0 1 0 0-2.153 1.077 1.077 0 0 0 0 2.153"
        />
        <path
          fill="#1D2124"
          d="M9.306 38.906 26.52 56.123l.16-.16 1.834 1.833 35.243-35.242-1.834-1.834.108-.108-6.411-6.415.159-.159 8.511 8.512-35.776 35.779L9.2 39.013z"
        />
        <path
          fill="#1D2124"
          d="m17.551 30.66 8.969 8.97.16-.161-8.97-8.967zM26.549 56.095l1.965 1.965 35.512-35.51-8.244-8.244-.027.027 6.276 6.279z"
        />
        <path
          fill="#1D2124"
          d="m26.547 39.602-8.833-8.836-.029.028 8.835 8.835z"
        />
        <path
          fill="#1D2124"
          d="M51.08 31.563a24.6 24.6 0 0 1 1.488 8.44c0 13.596-11.065 24.661-24.662 24.661S3.245 53.603 3.245 40.003c0-13.596 11.061-24.662 24.661-24.662a24.57 24.57 0 0 1 16.53 6.374l.267-.267a24.94 24.94 0 0 0-16.797-6.484c-13.807 0-25.039 11.235-25.039 25.039S14.1 65.042 27.907 65.042s25.038-11.232 25.038-25.04c0-3.07-.555-6.013-1.57-8.733z"
        />
        <path
          fill="#1D2124"
          d="M26.52 56.387 7.208 37.071l8.511-8.51 10.805 10.8 27.264-27.264 8.511 8.51zM7.74 37.071l18.78 18.784 35.243-35.243-7.979-7.979L26.52 39.897l-10.804-10.8zM42.458 15.81l-.559-1.65a3.3 3.3 0 0 0-2.059-2.06l-1.65-.559 1.65-.559a3.3 3.3 0 0 0 2.06-2.059l.558-1.65.56 1.65a3.3 3.3 0 0 0 2.058 2.06l1.651.558-1.65.56a3.3 3.3 0 0 0-2.06 2.058zm-3.086-4.269.59.2a3.68 3.68 0 0 1 2.296 2.297l.2.59.2-.59a3.68 3.68 0 0 1 2.297-2.297l.594-.2-.593-.2a3.68 3.68 0 0 1-2.297-2.297l-.2-.59-.2.59a3.68 3.68 0 0 1-2.298 2.297zM37.596 8.054a1.266 1.266 0 1 1 0-2.531 1.266 1.266 0 0 1 0 2.531m0-2.153a.887.887 0 1 0 0 1.776.887.887 0 1 0 0-1.776"
        />
      </g>
      <defs>
        <clipPath id="clip0_10273_589">
          <path fill="#fff" d="M0 0h68v68H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default IllustrationStickerCheck;
